<template>
    <ds-modal
        is-open
        size="sm"
        show-close
        :title="title"
        @close="$emit('close')"
    >
        <p class="description">
            {{ $t('ecomm.setup.max.classic.payment.and.deposit.dashboard.popup.message') }}
            <a href="https://help.infusionsoft.com/help/payment-options-in-infusionsoft" target="_blank">Learn more</a>
        </p>
    </ds-modal>
</template>

<script>
export default {
    props: {
        title: String,
    },
};
</script>
